import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';

import users_list from './users.list';
import users_view from './users.view';

export default function UserIndex() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = users_list;
      break;

    case 'view':
      ActualPage = users_view;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

